module.exports = __webpack_public_path__ + "static/media/Image_pola.985d941a.svg";